// Sidebar menu definition, shared by Sidebar.jsx (navigation) and Header.jsx (page search).
// `key` is the UserAccess page key checked with canAccessPage(); null = every logged-in user.
import { FiUsers } from "react-icons/fi";
import { LiaUserTieSolid, LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { HiOutlineWrenchScrewdriver } from "react-icons/hi2";
import { IoMdGlobe } from "react-icons/io";
import { BsHouse, BsJournalBookmarkFill, BsShieldLock, BsBarChart } from "react-icons/bs";
import { FiLayers, FiBox, FiActivity, FiAward, FiTrendingUp, FiCalendar } from "react-icons/fi";
import { TbHistory, TbReportAnalytics, TbUserDollar } from 'react-icons/tb';
import { FaHelmetSafety} from 'react-icons/fa6';
import { LiaUsersSolid } from "react-icons/lia";

// ── All possible menu items with their page keys ──────────────────────────
export const topItems = [
  {
    key: 'dashboard',
    name: 'Home',
    path: '/home',
    icon: <BsHouse size={18} />,
  },
  {
    // No page key — visible to every logged-in user, same as Home; the
    // calendar's own data is scoped by role server-side.
    key: null,
    name: 'Calendar',
    path: '/calendar',
    icon: <FiCalendar size={18} />,
  },
  {
    key: 'master_customers',
    name: 'Customers',
    path: '/master/customers',
    icon: <LiaUserTieSolid size={20} />,
  },
  {
    key: 'master_inspectors',
    name: 'Inspectors',
    path: '/master/inspectors',
    icon: <FaHelmetSafety size={18} />,
  },
  {
    key: 'enquiry_register',
    name: 'Enquiry Register',
    path: '/enquiry',
    icon: <BsJournalBookmarkFill size={18} />,
  },
  {
    key: 'user_management',
    name: 'Users',
    path: '/user-management',
    icon: <FiUsers />,
  },
  {
    key: 'access_panel',
    name: 'Access Panel',
    path: '/access-panel',
    icon: <BsShieldLock size={18} />,
  },

  {
    key: 'company_management',
    name: 'Company',
    path: '/company-management',
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
      <path d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022M6 8.694 1 10.36V15h5zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309z" />
    </svg>,
  },
  {
    key: 'past_records',
    name: 'Past Records',
    path: '/past-records',
    icon: <TbHistory />,
  },
];

export const masterItems = [
  {
    key: 'master_vendors',
    name: 'Vendors',
    path: '/master/vendors',
    icon: <LiaUsersSolid size={18} />,
  },
  {
    key: 'master_discipline',
    name: 'Disciplines',
    path: '/master/discipline',
    icon: <FiBox size={18} />,
  },
  {
    key: 'master_subdiscipline',
    name: 'Sub-Disciplines',
    path: '/master/subdiscipline',
    icon: <FiLayers size={18} />,
  },
  {
    key: 'master_product',
    name: 'Products',
    path: '/master/product',
    icon: <HiOutlineWrenchScrewdriver size={18} />,
  },
  {
    key: 'master_service',
    name: 'Services',
    path: '/master/service',
    icon: <FiActivity size={18} />,
  },
  {
    key: 'master_certificate',
    name: 'Certificates',
    path: '/master/certificate',
    icon: <FiAward size={18} />,
  },
];

export const financeItems = [
  { key: 'finance_dashboard',        name: 'Dashboard',      path: '/finance/dashboard',        icon: <BsBarChart size={16} /> },
  { key: 'finance_customer_invoice',   name: 'Customer Invoice',   path: '/finance/customer-invoice',   icon: <LiaFileInvoiceDollarSolid size={20} /> },
  { key: 'finance_inspection_invoice', name: 'Inspection Invoice', path: '/finance/inspection-invoice', icon: <TbUserDollar size={20} /> },
  { key: 'finance_currency_rates',     name: 'Currency Rates', path: '/finance/currency-rates',     icon: <FiTrendingUp size={18} /> },
];

export const dashboardItems = [
  {
    key: 'dashboard_coordinator',
    name: 'Coordinator',
    path: '/dashboard/coordinator',
    icon: <TbReportAnalytics size={20} />,
  },
  {
    key: 'dashboard_customer_vendor',
    name: 'Customer Vendor',
    path: '/dashboard/customer-vendor',
    icon: <IoMdGlobe size={20} />,
  },
];

// Flat list of every page with its menu group, for the header search.
export const allMenuPages = [
  ...topItems.map(i => ({ ...i, group: null })),
  ...dashboardItems.map(i => ({ ...i, group: 'Dashboard' })),
  ...financeItems.map(i => ({ ...i, group: 'Finance' })),
  ...masterItems.map(i => ({ ...i, group: 'Master' })),
];
